export default __webpack_public_path__ + "9045ca3f6a0b65db0a86539cfa249341.png";